import { render, staticRenderFns } from "./TeamView.vue?vue&type=template&id=531576be&"
import script from "./TeamView.vue?vue&type=script&lang=js&"
export * from "./TeamView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports